import { makeStyles } from '@material-ui/styles';

import { neutral } from 'shared/styles/colors';

export default makeStyles({
  article: {
    display: 'flex',
    gap: '1rem',
    flexDirection: 'column',
  },

  product: {
    display: 'flex',
    gap: '1rem',
  },
  productHeader: {
    display: 'flex',
    gap: '1rem',
    justifyContent: 'space-between',
    '& *': {
      fontWeight: 600,
      fontSize: '1rem',
      lineHeight: '1.5rem',
    },
    '& > h2 > span': {
      paddingRight: '0.25rem',
    },
  },
  productDescription: {
    fontWeight: 400,
    fontSize: '0.75rem',
    lineHeight: '1.25rem',
    color: neutral[60],
  },
});
